import { render, staticRenderFns } from "./InfoBox.vue?vue&type=template&id=1d3e0aa2&"
import script from "./InfoBox.js?vue&type=script&lang=js&"
export * from "./InfoBox.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/mijnmooiestraat.vlaanderen/develop.mijnmooiestraat.vlaanderen/pro-develop.mijnmooiestraat.vlaanderen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d3e0aa2')) {
      api.createRecord('1d3e0aa2', component.options)
    } else {
      api.reload('1d3e0aa2', component.options)
    }
    module.hot.accept("./InfoBox.vue?vue&type=template&id=1d3e0aa2&", function () {
      api.rerender('1d3e0aa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/InfoBox/InfoBox.vue"
export default component.exports